import React from 'react';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {
  selectPathologist,
} from '../../redux/actions';


const InboxListItemPathologistSelector = ({ clickedCase, currentPathologist, selectPathologist }) => {

  const { pathologists } = clickedCase;
  return (
    <List>
      {pathologists.map(pathologist => (
        <ListItem
          key={pathologist._id}
          selected={pathologist._id === currentPathologist._id}
          button
          dense
          onClick={() => { selectPathologist(pathologist); }}
        >
          <ListItemText
            primary={pathologist.name}
          />

        </ListItem>
      ))}
    </List>
  );
};
const mapStateToProps = ({ _case }) => {
  const { currentPathologist } = _case;
  return { currentPathologist };
};

export default connect(mapStateToProps, {
  selectPathologist,
})(InboxListItemPathologistSelector);
